<template>
  <main
    class="flex flex-col w-full h-full gap-5 p-6 overflow-x-hidden overflow-y-auto bg-n-background no-scrollbar"
  >
    <router-view />
  </main>
</template>
